import { render, staticRenderFns } from "./operation.vue?vue&type=template&id=36076ab7&scoped=true"
import script from "./operation.vue?vue&type=script&lang=js"
export * from "./operation.vue?vue&type=script&lang=js"
import style0 from "./operation.vue?vue&type=style&index=0&id=36076ab7&prod&scoped=true&lang=css"
import style1 from "./operation.vue?vue&type=style&index=1&id=36076ab7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36076ab7",
  null
  
)

export default component.exports